import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { WidgetTypes } from '@src/helpers/Enums';
import I18n from '@src/i18n';
import { Popover } from 'antd';
import React from 'react';

import AditionalContent from './AditionalContent';
import { PopoverContainer, WidgetBox } from './styles';

type PropType = {
  data: any;
  title: string;
  id: any;
  unit: any;
  widgetID: string;
  deleteWidgetByIndex: Function;
  editWidget?: Function;
  isPreview?: boolean;
  widget?: any;
  processes: any;
  duplicateWidget: Function;
  processId: any;
  recurrence: boolean;
}


function deleteWidget(props: any) {
  props.deleteWidgetByIndex(props.id, props.widgetID)
}

function duplicateWidget(props: any){
  props.duplicateWidget();
}

function editWidget(props: any) {
  props.editWidget()
}

function popoverContent(props: any) {
  return (
    <PopoverContainer>
    <div style={{ display: 'flex' }} className="popover-row" onClick={() => editWidget(props)} >
      <div className="icon">
        <FontAwesomeIcon icon={'edit'} />
      </div>
      <div className="text">
        <p>{I18n.l('common.edit')}</p>
      </div>
    </div>

    <div style={{ display: 'flex' }} className="popover-row" onClick={() => duplicateWidget(props)}>
      <div className="icon">
        <FontAwesomeIcon icon={'clone'} />
      </div>
      <div className="text">
        <p>{I18n.l('common.duplicate')}</p>
      </div>
    </div>

    <div style={{ display: 'flex' }} className="popover-row" onClick={() => deleteWidget(props)}>
      <div className="icon">
        <FontAwesomeIcon icon={'trash'} />
      </div>
      <div className="text">
        <p>{I18n.l('common.delete')}</p>
      </div>
    </div>
  </PopoverContainer>
  )

}

 const groupByUser = (data: any, processes: any, processId: string) => {
  if(data){
    const usersObj = {}
    for(let i in data){
      let auditedID;
      if(data[i] && data[i].audited && data[i].audited.id) {
        auditedID = data[i].audited.id
      if(usersObj[auditedID]){
        if(data[i].components){
          const components = data[i].components.map((e: any) => e.key)
        for(let component of components){
          let foundComponent = usersObj[auditedID].components.find((e: any) => e.key === component)
          if(foundComponent){
            let foundCompIndex = usersObj[auditedID]['components'].indexOf(foundComponent)
            let formerItem = usersObj[auditedID]['components'][foundCompIndex] 
            let newItem = Object.assign({} , formerItem, { reincident: true })
            usersObj[auditedID]['components'][foundCompIndex] = newItem
          } else {
            usersObj[auditedID]['components'].push({key: component, reincident: false})
          }
        }
        }
      } else {
        if(data[i].components){
        usersObj[auditedID] = {
          name: data[i].audited.name,
          components: data[i].components.map((e: any) => {return {key: e.key, reincident: false}})
        }
      }
      }
    }
    }
    let returnedArray = []
    if(usersObj){
      for(
        let i in usersObj){
        returnedArray.push(usersObj[i])
      }
    }
    let processObject = processes.items.find((e: any) => e.id === processId)
    const finalArray = []
    for(let i in returnedArray){
      let newComponents: any = []
      returnedArray[i].components.map((e: any) => {
        let namedObject = processObject.paths.find((l: any) => l.key === e.key)
        let name = namedObject.value
        if (name.indexOf('>') !== -1) name = name.slice(0, (name.indexOf('>') - 1))
        let newObject = Object.assign({}, e, { name })
        newComponents.push(newObject)
      })
      let filteredComponents = []
      const nameObj: any = []
      for(let i in newComponents){
        if(nameObj[newComponents[i].name]){
          nameObj[newComponents[i].name].reincident = true
        } else {
          nameObj[newComponents[i].name] = newComponents[i]
        }
      }
      for(let i in nameObj){
        filteredComponents.push(nameObj[i])
      }
      finalArray.push(filteredComponents)
    }
    for(let i in returnedArray){
      returnedArray[i].components = finalArray[i]
    }
    return returnedArray
  } else {
    return []
  }
 }


 
 function formatData(groupedUsers: any, processes: any, recurrence: boolean, processID: any) {
  if(groupedUsers && processes && processID){
    let processObject = processes.items.find((e: any) => e.id === processID)
    let keyFilteredArray = []
      for(let user of groupedUsers){
        const selectedComponents = []
        for(let component of user.components){
          let label = processObject.paths.find((e:any) => e.key === component.key)
          let name = label.value
          if(name.indexOf('>') !== -1) name = name.slice(0, (name.indexOf('>') - 1))
          const newComponent = Object.assign({}, component, {name: name})
          if(recurrence){
            if(component.reincident) selectedComponents.push(newComponent)
          } else {
            selectedComponents.push(newComponent)
          }
        }
        let reincidentFiltered = Object.assign({}, user, {components: selectedComponents})
        keyFilteredArray.push(reincidentFiltered)
        keyFilteredArray = keyFilteredArray.filter((e: any) => e.components.length > 0)
      }
      return keyFilteredArray
  } else {
    return []
  }
 }  

const Table = (props: PropType) => {
  let processes;
  let recurrence = props.recurrence ? props.recurrence : false;
  let processID;
  if(props.processes) processes = props.processes;
  if(props.processId) processID = props.processId;
  const initialValues = groupByUser(props.data, processes, processID);
  const newData = formatData(initialValues, processes, recurrence, processID);
  return (
    <WidgetBox className={`-list ${props.isPreview ? "-preview" : ''}`}>
      <div className="up">
        <div className="title">
          {props.title}
        </div>
        <div className="edit custom"  >
          {!props.isPreview &&
            <div className="please-disapear no-padding">
              <Popover
                placement='bottom'
                trigger="hover"
                content={popoverContent(props)}
              >
                <FontAwesomeIcon icon={"cog"} />
              </Popover>
            </div>
          }
        </div>
      </div>
      <div className="bottom">
      {newData && newData.length === 0 &&
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <h1 style={{fontWeight: 400}}>{I18n.l('dashboard.noData')}</h1>
          </div>
      }
        {newData && newData.length > 0 && 
        <div className="table-container">
          <div className="table-header">
            <div className="left-side-title">
              <h3>{I18n.l('common.users')}</h3>
            </div>
            <div className="right-side-title">
              <h3>{I18n.l('common.categories')}</h3>
            </div>
          </div>
          <table>
            <tbody>
            {newData.map((singleData) =>
              <tr key={singleData.name}>
              <>
                <td className="table-name">{singleData.name}</td>
                <td className="table-content">
                  <ul>
                  {singleData.components.map((e: any) => <li key={e.key} className="list-item">{e.name}</li>)}
                  </ul>
                  </td>
              </>
              </tr>)}
              </tbody>
          </table>
        </div> }
        <AditionalContent type={WidgetTypes.LIST} widget={props.widget} count={newData ? newData.length : 0} />
      </div>
    </WidgetBox>
  )
}

export default Table

